import React from 'react';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import {
	getCategoryNamesDisplay,
	getReviewTagsWithCount,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { AddressDisplay } from '../address_display/AddressDisplay';
import RatingComponent from '../RatingComponent';
import { Button, message, Tag } from 'antd';
import renderWithHighlight from '../RenderHighlight';
import SupplierPrivateNetworkCreateForm from '../supplier_private_network_create_form/SupplierPrivateNetworkCreateForm';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';
import {
	createSupplierPrivateNetworkBulkForBuyer,
	createSupplierPrivateNetworkBulkForSupplier,
} from '../../thunks/supplier_private_networks_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { getAllSupplierPrivateNetworkEntities } from '../supplier_private_network_create_form/supplier_private_network_utils';
import OWLink from '../OWLink';

class SupplierRecord extends React.Component<any, any> {
	formRefs: any = {
		supplierPrivateNetworkCreateForm: null,
	};
	constructor(props) {
		super(props);
		this.state = {
			creatingPrivateNetwork: false,
			supplierPrivateNetworkCreateFormVisible: false,
		};
	}

	handleSupplierPrivateNetworkCreateSubmit = (...args) => {
		const form = this.formRefs['supplierPrivateNetworkCreateForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			this.setState({ creatingPrivateNetwork: true });
			const allSNs = getAllSupplierPrivateNetworkEntities(values);

			this.props
				.createSupplierPrivateNetworkBulk(allSNs)
				.then(() => {
					this.setState({ supplierPrivateNetworkCreateFormVisible: false });
					message.success(`Supplier added to your private network.`);
					this.props.onAddNetwork && this.props.onAddNetwork();
				})
				.finally(() => this.setState({ creatingPrivateNetwork: false }));
		});
	};
	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	render() {
		const { record, userType, privateNetwork } = this.props;
		const { creatingPrivateNetwork, supplierPrivateNetworkCreateFormVisible } = this.state;

		if (!record) return null;

		return (
			<>
				<SupplierPrivateNetworkCreateForm
					userType={userType}
					visible={supplierPrivateNetworkCreateFormVisible}
					supplierFacilityId={supplierPrivateNetworkCreateFormVisible ? record.id : undefined}
					onCancel={() => {
						this.setState({ supplierPrivateNetworkCreateFormVisible: false });
					}}
					onSubmit={this.handleSupplierPrivateNetworkCreateSubmit}
					loading={creatingPrivateNetwork}
					wrappedComponentRef={this.saveFormRef('supplierPrivateNetworkCreateForm')}
				/>

				<OWLink to={`/${userType}/suppliers/detail/${record.id}`}>
					<div style={{ display: 'flex', alignItems: 'center', padding: 16 }}>
						<div style={{ marginRight: 24 }}>
							{record.logoURL ? (
								<FlexibleImageAvatar
									displayName={record.displayName}
									showPopover={false}
									popoverText={record.displayName}
									squareMode={true}
									width="120px"
									height="80px"
									imageUrl={record.logoURL}
								/>
							) : (
								<FlexibleImageAvatar
									displayName={record.displayName}
									showPopover={false}
									popoverText={record.displayName}
									squareMode={true}
									width="120px"
									height="80px"
									imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-city-filled-100.png"
								/>
							)}
						</div>
						<div style={{ flex: 1 }}>
							<div
								style={{
									display: 'flex',
								}}
							>
								<div
									style={{
										fontSize: 18,
										wordBreak: 'break-word',
										marginRight: 8,
									}}
								>
									{renderWithHighlight(record.highlight, 'displayName', record.displayName)}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<div>
									{record.categoryNames && record.categoryNames.length ? (
										<div style={{ marginBottom: 0, fontSize: 14 }}>
											<div
												style={{
													wordBreak: 'normal',
													whiteSpace: 'normal',
													color: 'rgba(0,0,0,0.65)',
												}}
											>
												{getCategoryNamesDisplay(record.categoryNames)}
											</div>
										</div>
									) : null}

									<AddressDisplay
										hidePostcode={true}
										hideCountry={true}
										hideStreetAddress={true}
										address={record.primaryAddress}
										style={{
											color: 'rgba(0,0,0,0.45)',
										}}
									/>
									{nullSafeGet('averageRating', record) ? (
										<RatingComponent
											rating={nullSafeGet('averageRating', record)}
											numRatings={nullSafeGet('numRatings', record)}
											tags={getReviewTagsWithCount(record)}
											tagCountToShow={3}
										/>
									) : null}
									{nullSafeGet('isNationalSupplier', record) ? <Tag>National Supplier</Tag> : null}
								</div>

								<div>
									<Button
										type="primary"
										onClick={(e) => {
											e.stopPropagation();
											e.preventDefault();
											this.setState({ supplierPrivateNetworkCreateFormVisible: true });
										}}
										disabled={privateNetwork.map((pn) => pn.supplierFacilityId).includes(record.id)}
									>
										Add to Network
									</Button>
								</div>
							</div>
						</div>
					</div>
				</OWLink>
			</>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	supplierFacilities: state.supplier_facilities,
	supplierFacilitiesFetching: state.supplier_facilities.searching,
	spendCategories: state.spend_categories,
	userType: (state as any).session.userType,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	createSupplierPrivateNetworkBulk: (entities) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? createSupplierPrivateNetworkBulkForSupplier(entities)
				: createSupplierPrivateNetworkBulkForBuyer(entities)
		),
});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(SupplierRecord));
